import { render, staticRenderFns } from "./closeable-header-label.vue?vue&type=template&id=090d5ac2&"
import script from "./closeable-header-label.vue?vue&type=script&lang=js&"
export * from "./closeable-header-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports